import { CheckoutsEffects } from 'libs/ng-common-lib/src/+state/checkouts.effects';
import { DealerEffects } from 'libs/ng-common-lib/src/+state/dealer.effects';
import { WholesaleEffects } from 'libs/ng-common-lib/src/+state/wholesale.effects';
import { FilterEffects } from './filter.effects';
import { VehicleEffects } from './vehicle.effects';

export const effects = [DealerEffects, FilterEffects, VehicleEffects, CheckoutsEffects, WholesaleEffects];
